var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90614 0C13.8171 0 17.8123 3.99519 17.8123 8.90614C17.7822 13.7359 12.3862 19.6545 8.90614 23.6204C5.42683 19.6553 0.0292978 13.7347 0 8.90614C0 3.99519 3.99519 0 8.90614 0Z",
    fill: "#45AF77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90614 14.6255C11.9143 14.6255 14.3674 12.1721 14.3674 9.16428C14.0879 1.9297 3.7228 1.93168 3.44447 9.16428C3.44447 12.1725 5.89797 14.6255 8.90574 14.6255H8.90614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.77d86ea9a7a52c872d2f6f2e049f300c.svg";
export { ForwardRef as ReactComponent };